export default __webpack_public_path__ + "static/cabin-latin-400-normal-494cb48a046d2d2e69e0e45d1141586f.woff2";